import { createAsyncThunk } from '@reduxjs/toolkit';

import teamService from '../../services/teamService';

export const inviteUser = createAsyncThunk(
  'team/inviteUser',
  async ({ teammateEmail, organizationId, message, permissionLevel, onboardingInvite, location }, { rejectWithValue }) => {
    let userInvitedResponse = null;

    try {
      userInvitedResponse = await teamService.inviteUser(
        teammateEmail,
        organizationId,
        message,
        permissionLevel,
        onboardingInvite,
        location
      );
    } catch (err) {
      userInvitedResponse = rejectWithValue(err);
    }

    return userInvitedResponse;
  }
);

export const referUser = createAsyncThunk('team/referUser', async ({ email, message }, { rejectWithValue }) => {
  let userReferredResponse = null;

  try {
    userReferredResponse = await teamService.referUser(email, message);
  } catch (err) {
    userReferredResponse = rejectWithValue(err);
  }
  return userReferredResponse;
});

export const editTeam = createAsyncThunk(
  'team/editTeam',
  async (
    { id, teamName, teamColor, teamLogo, teamUrl, geo, dept, removeLogo, accessLevel, confluence_export_type, confluence_auth },
    { rejectWithValue }
  ) => {
    let retVal = null;

    try {
      retVal = await teamService.editTeam(id, {
        name: teamName,
        color: teamColor,
        logo: teamLogo,
        team_url: teamUrl,
        geo,
        dept,
        remove_logo: removeLogo,
        access_level: accessLevel,
        confluence_export_type,
        confluence_auth
      });
    } catch (err) {
      retVal = rejectWithValue(err);
    }
    return retVal;
  }
);

// If this code is modified, you MUST update accountSlice which responds to these actions using a string
export const createTeam = createAsyncThunk('team/createTeam', async ({ teamName, description, accessLevel }, { rejectWithValue }) => {
  try {
    return await teamService.createTeam(teamName, description, accessLevel);
  } catch (error) {
    return rejectWithValue(error);
  }
});
